import React from "react";
import { Modal, Table, Button } from "react-bootstrap";

const OutOfStockModal = ({ show, onHide, medicationListing }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Medicine Out of Stock</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: "calc(100vh - 170px)",
          overflow: "auto",
        }}
      >
        <Table responsive>
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>Sr.No</th>
              <th style={{ textAlign: "center" }}>Medicine</th>
              <th style={{ textAlign: "center" }}>Order Quantity</th>
              <th style={{ textAlign: "center" }}>Available Quantity</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "14px" }}>
            {medicationListing.map((x, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "center" }}>
                  {(x.description && x.description.label) ||
                    (x.selectmedication && x.selectmedication.label)}
                </td>
                <td style={{ textAlign: "center" }}>{x.quantity}</td>
                <td style={{ textAlign: "center" }}>{x.pharmacyLevelQuantity}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="info" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OutOfStockModal;
